<div class="d-flex justify-content-between align-items-center py-1 px-3 paginatorWrapper">
  <ng-template [ngTemplateOutlet]="detailTemplate ?? emptyTemplate" />
  @if (loading || hasNextPage()) {
    <chitin-button
      class="load-more-btn"
      data-cy="loadMoreBtn"
      data-testid="loadMoreBtn"
      label="Load more"
      [isLoading]="loading"
      (clicked)="nextPage()"
    />
  }
  @if (!loading && length > 0) {
    <div class="resultsInfo text-end" data-cy="paginator" data-testid="paginator">
      Showing {{ Math.min((pageIndex + 1) * pageSize, totalItems ?? length) }} out of {{ totalItems ?? length }} items.
    </div>
  }
</div>

<ng-template #emptyTemplate>
  <div></div>
</ng-template>
